
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trades/[trade]",
      function () {
        return require("private-next-pages/trades/[trade].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trades/[trade]"])
      });
    }
  